import React, { useEffect } from 'react';

const FormlessWidget = () => {
  useEffect(() => {
    // Remove any existing scripts first
    const existingScripts = document.querySelectorAll('script[src*="formless.ai"]');
    existingScripts.forEach(script => script.remove());
    
    // Also remove by ID if it exists
    const existingScript = document.getElementById('formless_embed');
    if (existingScript) {
      existingScript.remove();
    }

    // Wait a moment for cleanup, then add new script
    setTimeout(() => {
      // Create and load the Formless AI script with updated parameters
      const script = document.createElement('script');
      script.id = 'formless_embed';
      script.src = 'https://embed.formless.ai/embed.js';
      script.async = true;
      script.setAttribute('data-type', 'trigger');
      script.setAttribute('data-trigger-bg-color', '#f2117b');
      script.setAttribute('data-trigger-icon-color', '#FFFFFF');
      script.setAttribute('data-trigger-icon-type', 'chat');
      script.setAttribute('data-conversation-id', 'b54qzzsJ66SR');

      // Add script to body
      document.body.appendChild(script);
    }, 100);

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[src*="formless.ai"]');
      scripts.forEach(script => script.remove());
      
      const scriptById = document.getElementById('formless_embed');
      if (scriptById) {
        scriptById.remove();
      }
    };
  }, []);

  return null; // This component doesn't render anything itself
};

export default FormlessWidget;